// no baseURI

const chunkImports = {
	"64": () => (import("./64.js")),
	"656": () => (import("./656.js")),
	"408": () => (import("./408.js"))
};

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, Promise] = chunk loading, 0 = chunk loaded
const installedChunks = {
	792: 0
};

const installChunk = (data) => {
	let {__webpack_esm_ids__, __webpack_esm_modules__, __webpack_esm_runtime__} = data;
	// add "modules" to the modules object,
	// then flag all "ids" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	for(moduleId in __webpack_esm_modules__) {
		if(__webpack_require__.o(__webpack_esm_modules__, moduleId)) {
			__webpack_require__.m[moduleId] = __webpack_esm_modules__[moduleId];
		}
	}
	if(__webpack_esm_runtime__) __webpack_esm_runtime__(__webpack_require__);
	for(;i < __webpack_esm_ids__.length; i++) {
		chunkId = __webpack_esm_ids__[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}

}

__webpack_require__.f.j = (chunkId, promises) => {
		// import() chunk loading for javascript
		let installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[1]);
			} else {
				if(true) { // all chunks have JS
					// setup Promise in chunk cache
					let promise = chunkImports[chunkId]().then(installChunk, (e) => {
						if(installedChunks[chunkId] !== 0) installedChunks[chunkId] = undefined;
						throw e;
					});
					promise = Promise.race([promise, new Promise((resolve) => (installedChunkData = installedChunks[chunkId] = [resolve]))])
					promises.push(installedChunkData[1] = promise);
				}
			}
		}
};

// no prefetching

// no preloaded

// no external install chunk

// no on chunks loaded
// no HMR

// no HMR manifest